/**
 * Puts a file on a presigned URL the API handed out (`POST /uploads/presign`). The browser talks
 * to S3 directly, so the API never carries file bytes; the content type must match the one the
 * URL was signed for.
 *
 * @param {object} input -- The presigned URL, the file and its content type.
 * @returns The ETag S3 answered with, when exposed.
 * @throws {Error} When S3 refuses the upload (expired URL, wrong content type, size mismatch).
 */
export const uploadToPresignedUrl = async (input: {
  url: string;
  file: Blob;
  contentType: string;
  fetchImpl?: typeof fetch;
}): Promise<{ etag: string | null }> => {
  const doFetch = input.fetchImpl ?? fetch;
  const response = await doFetch(input.url, {
    method: 'PUT',
    headers: { 'content-type': input.contentType },
    body: input.file,
  });
  if (!response.ok) {
    throw new Error(`Upload refused (${response.status})`);
  }
  return { etag: response.headers.get('etag') };
};
